module.exports = __webpack_public_path__ + "img/Porto Apartment - 83 of 85.095097fa.jpeg";